export const CCopyBlockFragments = {
  wysiwygBlock: `
    fragment wysiwyg_copyBlock on wysiwyg_copyBlock_Entry {
      typeHandle
      idName
      containerMaxWidth
      copy
    }
  `,
  customComponentsLandingPageBlock: `
    fragment customComponentsLandingPage_copyBlock on customComponentsLandingPage_copyBlock_Entry {
      typeHandle
      idName
      containerMaxWidth
      copy
    }
  `,
}
